module.exports = __webpack_public_path__ + "static/media/Santa Clara Street, Brisbane, CA5.22dfc8bb.jpg";